

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEKRAKPIANSWER= createAsyncThunk(
  "createKraKpiAnswer/createKraKpiAnswer",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createKraKpiAnswerSlice = createSlice({
  name: "createKraKpiAnswerSlice",
  initialState: {
    createKraKpiAnswer: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateKraKpiAnswer: (state) => {
        state.createKraKpiAnswer.loading = false
        state.createKraKpiAnswer.error = false
        state.createKraKpiAnswer.data = []
        state.createKraKpiAnswer.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEKRAKPIANSWER.fulfilled, (state, action) => {
      state.createKraKpiAnswer = {
        ...state.createKraKpiAnswer,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEKRAKPIANSWER.pending, (state, action) => {
      state.createKraKpiAnswer = {
        ...state.createKraKpiAnswer,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEKRAKPIANSWER.rejected, (state, action) => {
      state.createKraKpiAnswer = {
        ...state.createKraKpiAnswer,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createKraKpiAnswerAction = {
    CREATEKRAKPIANSWER,
};

export { createKraKpiAnswerAction };
export default createKraKpiAnswerSlice.reducer;
export const {setInitialStateOfcreateKraKpiAnswer} = createKraKpiAnswerSlice.actions
